export const IntroSectionData = {
  left: {
    heading: "Who Am I?",
    description:
      "Hello, I'm Naimur, a Python Backend Developer specializing in Django, FastAPI, PostgreSQL, and automation. I have experience with React, Next.js, and Svelte, along with a strong interest in deep learning and AI. I'm currently focused on building reliable backend systems, improving my software architecture skills. Recently I've been using coding agents to ship working software faster than ever.",
  },
  right: {
    top: {
      totalExpYears: "4",
      totalToolsUsed: "17",
    },

    bottom: {
      name: "Naimur Rahman",
      languages: "ENG/BNG/GER",
      freelancing: "Available",
      location: "Dhaka, Bangladesh",
      phone: "+8801843034859",
      email: "prof.naimur29@gmail.com",
    },
  },
};
